<template>
  <v-card :elevation="0" width="100%">
    <v-card>
      <v-simple-table>
        <template v-slot:default>
          <tbody v-if="data.length && data[currentIndex]">
            <tr v-for="(label, key) in keys" :key="key">
              <td class="font-weight-bold">{{ $t(label) }}</td>
              <td>{{ data[currentIndex][key] }}</td>
            </tr>
          </tbody>
          <div v-else-if="error">
            <v-card
              class="d-flex align-center justify-center mx-auto my-auto"
              color="error"
              dark
              min-height="293"
            >
              <v-card-text class="text-center">
                <v-icon size="64" class="mb-5" style="opacity: 0.7"
                  >mdi-alert-circle-outline</v-icon
                >
                <h2 class="mb-5">{{ $t('COULD NOT FIND REGISTRATION DETAILS') }}</h2>
                <h4 class="mb-2">{{ $t('Try registering the star again!') }}</h4>
                <h4>{{ $t("If it doesn't work, please contact the developer!") }}</h4>
              </v-card-text>
            </v-card>
          </div>
          <tbody style="pointer-events: none" v-else>
            <tr v-for="key in Object.keys(keys)" :key="key">
              <td><v-skeleton-loader type="list-item"></v-skeleton-loader></td>
              <td><v-skeleton-loader type="list-item"></v-skeleton-loader></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <div class="navigation-buttons" v-if="data.length > 1">
      <v-btn fab small :disabled="currentIndex === 0" @click="previousItem" class="mx-2">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <div class="text-overline">{{ currentIndex + 1 }} / {{ data.length }}</div>
      <v-btn fab small :disabled="currentIndex === data.length - 1" @click="nextItem" class="mx-2">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>

<script>
  export default {
    props: {
      error: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Array,
        required: true,
        default: () => [],
      },
      keys: {
        type: Object,
        default: () => ({
          registryKey: 'Registry Key',
          registerName: 'Registered Name',
          registerDate: 'Registration Date',
          registeredBy: 'Registered By',
          starName: 'Registered Star',
          greetMessage: 'Greeting Message',
        }),
      },
    },
    data() {
      return {
        currentIndex: 0,
      }
    },
    methods: {
      nextItem() {
        if (this.currentIndex < this.data.length - 1) {
          this.currentIndex++
        }
      },
      previousItem() {
        if (this.currentIndex > 0) {
          this.currentIndex--
        }
      },
    },
  }
</script>

<style scoped>
  .navigation-buttons {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 5px;
    padding-bottom: 10px;
  }
</style>
